<template>
    <div>
        <p class="text-16 mb-1">-</p>
        <p class="text-16 mb-3">-</p>
        <div class="mb-3">
            <product-item v-for="product in order.products" :key="product.id" :product="product"></product-item>
        </div>
    </div>
</template>

<script>
export default {
    props: ['order'],
}
</script>
